import HeroSection from './components/HeroSection';
import SelfCheckSection from './components/SelfCheckSection';
import WhySection from './components/WhySection';
import TherapistSection from './components/TherapistSection';
import TestimonialsSection from './components/TestimonialsSection';
import SessionInfoSection from './components/SessionInfoSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';
import WhisperText from './components/WhisperText';

export default function Home() {
  return (
    <main className="font-sans bg-[#FAF8F5] min-h-screen">
      {/* Section 1 - Hero */}
      <HeroSection />

      {/* Whisper 1 */}
      <WhisperText text="全部自分のせいだと思っていた。——それが、思い込みだったとしたら。" />

      {/* Section 2 - Self Check */}
      <SelfCheckSection />

      {/* Whisper 2 */}
      <WhisperText text="——「誰かのため」には頑張れるのに、「自分のためだけ」に頑張るのは許せない人へ。" />

      {/* Section 3 - Why Cards */}
      <WhySection />

      {/* Whisper 3 */}
      <WhisperText text="——自分以上に自分を信じてくれる人がいます。" />

      {/* Section 4 - Therapist */}
      <TherapistSection />

      {/* Section 5 - Testimonials */}
      <TestimonialsSection />

      {/* Whisper 4 */}
      <WhisperText text="——自分を取り戻したいと感じてる方が、取り戻せる場所。" />

      {/* Section 6 - Session Info */}
      <SessionInfoSection />

      {/* Section 7 - CTA */}
      <CTASection />

      {/* Footer */}
      <FooterSection />
    </main>
  );
}
